import { render, staticRenderFns } from "./mySubmission.vue?vue&type=template&id=a2762dce&scoped=true"
import script from "./mySubmission.vue?vue&type=script&lang=js"
export * from "./mySubmission.vue?vue&type=script&lang=js"
import style0 from "./mySubmission.vue?vue&type=style&index=0&id=a2762dce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2762dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2762dce')) {
      api.createRecord('a2762dce', component.options)
    } else {
      api.reload('a2762dce', component.options)
    }
    module.hot.accept("./mySubmission.vue?vue&type=template&id=a2762dce&scoped=true", function () {
      api.rerender('a2762dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/examine/components/mySubmission.vue"
export default component.exports